import { fmt } from '../../utils/formatters';

export default function InvoiceItemsTableReadonly({ items }) {
  const hasDiscount = items?.some(it => Number(it.discount) > 0);

  return (
    <div className="items-wrap">
      <table className="items-table">
        <thead>
          <tr>
            <th>Description</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>VAT %</th>
            <th>VAT Amount</th>
            {hasDiscount && <th>Discount</th>}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((it, i) => {
            const lineVat = (Number(it.qty) * Number(it.unitPrice)) * (Number(it.vatRate) / 100);
            const discount = Number(it.discount) || 0;
            return (
              <tr key={i} className={it.isAutoAdded ? 'auto-item' : ''}>
                <td>
                  {it.description}
                  {it.isAutoAdded && <span className="auto-badge" style={{ marginLeft: 6 }}>auto</span>}
                </td>
                <td className="cell-center">{it.qty}</td>
                <td className="cell-num">{fmt(discount > 0 && it.matchedProductPrice ? it.matchedProductPrice : it.unitPrice)}</td>
                <td className="cell-center">{it.vatRate}%</td>
                <td className="cell-muted">{fmt(lineVat)}</td>
                {hasDiscount && (
                  <td className="cell-num" style={{ color: discount > 0 ? 'var(--danger, #9b2335)' : 'inherit', fontWeight: discount > 0 ? 600 : 400 }}>
                    {discount > 0 ? `-${fmt(discount)}` : '—'}
                  </td>
                )}
                <td className="cell-gold">{fmt(it.qty * it.unitPrice)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

